import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as startOfToday from 'date-fns/start_of_today';
import {map} from 'rxjs/operators';
import {SubmittalFeedbackType, TrackerCandidateStatus} from '../../../model';
import {toHtml, trackerCandidateStatusForId} from '../../../utils';
import {AppStateService} from '../../shared/app-state.service';
import {AuthService} from '../../shared/auth.service';
import {ProfileApiService} from '../profile-api.service';
import {SubmittalFeedbackService} from '../submittal-feedback.service';

@Component({
  selector: 'talent-summary',
  templateUrl: './talent-summary.component.html',
  styleUrls: ['./talent-summary.component.scss']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class TalentSummaryComponent implements OnInit, OnChanges {

  @Input() order: Order; // optional
  @Input() submittal: Submittal;
  @Input() profile: Talent.Profile;

  @Output() update = new EventEmitter<Submittal>();
  @Output() identify = new EventEmitter<void>();

  editable = false;
  rateDecorator: (value: string) => string;
  rateValidator: (value: string) => boolean;
  summaryFeedback: SubmittalFeedbackBody;

  toHtml = toHtml;
  now = startOfToday();

  user$ = this.Auth.user$;
  feedbackEnabled$ = this.user$.pipe(map(user => user && !user.admin));
  isJapan$ = this.AppState.locale$.pipe(map(locale => locale === 'ja-JP'));

  constructor(private AppState: AppStateService,
              private Auth: AuthService,
              private Api: ProfileApiService,
              private Translate: TranslateService,
              private SubmittalFeedback: SubmittalFeedbackService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.submittal) {
      this.profile = this.submittal.profile;
    }
  }

  ngOnInit() {
    this.Auth.user$.subscribe(user => this.editable = user && user.admin);
    this.rateDecorator = (value: string) =>
      `${this.submittal.currencySymbol}${parseFloat(value).toFixed(2)}${this.submittal.country === 'GB' ? '/hr' : ''}`;
    this.rateValidator = (value: string) => !isNaN(parseFloat(value));
    this.summaryFeedback = this.getSubmittalSummaryFeedback();
  }

  trackerCandidateStatusForId(id: number): string {
    return TrackerCandidateStatus[trackerCandidateStatusForId(id)];
  }

  updateProfile(update: Partial<Talent.Profile>) {
    const profile = {...this.profile, ...update};
    this.Api.saveProfile(this.submittal.id, profile)
      .subscribe(() => this.update.emit({...this.submittal, profile}),
        err => console.error('Failed to save profile.', err));
  }

  updateRate(value: string) {
    const rate = parseFloat(value);
    this.Api.saveRate(this.submittal.id, rate)
      .subscribe(() => this.update.emit({...this.submittal, rate}),
        err => console.error('Failed to save rate.', err));
  }

  updateSalary(talentBridgeSalary: string) {
    this.Api.saveSalary(this.submittal.id, talentBridgeSalary)
      .subscribe(() => this.update.emit({...this.submittal, talentBridgeSalary}),
        err => console.error('Failed to save salary.', err));
  }

  getSubmittalSummaryFeedback(): SubmittalFeedbackBody {
    if (this.submittal) {
      return this.SubmittalFeedback.createSubmittalFeedback(
        this.submittal.submittalFeedbackList,
        this.submittal.personId,
        SubmittalFeedbackType.summary
      );
    }
  }

  showIdentification(event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.identify.emit();
  }
}
